import React from "react";
import { Tooltip } from "antd";
import DocumentsCategoryBrowsing from "./documentsCategoryBrowsing";
import ModalZoom from "../../preview/modalZoom";
import DebounceInput from "../DebounceInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getDocumentsWithSearch,
  clearDocumentsWithSearch,
  getDocumentsWithSearchSimple
} from "../../../store/actions/documentsWithSearch";
import "./style.css";
import {
  loadDocumentPreview,
  loadDocumentDetail
} from "../../../store/actions/documentPreview";
import { Modal } from "@ts-digital/vrc";
import { FormattedMessage, injectIntl } from "react-intl";

class DocumentBrowsing extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      searchValue: "",
      searchDialog: false,
      browsingVisible: false,
      modalZoom: false,
      modalZoomPage: 1,
      documentBrowsingPage: 1,
      documentBrowsingCategory: "",
      docId: null,
      documents: {},
      isLoadingDocuments: false,
      isGettingDocumentsError: false
    };
    this.checkClick = this.checkClick.bind(this);
  }

  componentDidMount() {
    if (this.props.isDocumentDetails) {
      this.props.getDocumentsWithSearchSimple(
        null,
        "",
        this.props.accountantSelected,
        this.props.accountantIdSelected,
        this.props.companySelected,
        this.props.clientIdSelected
      );
    } else {
      this.props.getDocumentsWithSearch(null,
        "");
    }

    document.addEventListener("click", this.checkClick);
  }

  componentDidUpdate(prevProps, prevState) {
    /** Elimino margini Modale non sovrapponibile lo style per problemi di className random */
    let nearestElem = document.getElementsByClassName("openWindowContainer");
    if (nearestElem && nearestElem.length > 0) {
      nearestElem[0].parentNode.style.maxHeight = "calc(100vh - 140px)";
      nearestElem[0].parentNode.parentNode.style.marginTop = "70px";
    }
    if (this.props.getDocumentsSimple !== prevProps.getDocumentsSimple) {
      const getDocumentsStatus = this.props.getDocumentsSimple.status;
      this.setState({
        isLoadingDocuments: getDocumentsStatus.started === true ? true : false,
        isGettingDocumentsError:
          getDocumentsStatus.error === true ? true : false
      });
    }
  }

  checkClick(event) {
    if (event.target.id === `${this.props.id}_input`) {
      this.setState({ browsingVisible: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.checkClick);
  }

  resetDocuments() {
    const {
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected
    } = this.props;

    if (this.props.isDocumentDetails) {
      this.props.getDocumentsWithSearchSimple(
        null,
        "",
        accountantSelected,
        accountantIdSelected,
        companySelected,
        clientIdSelected
      );
    } else {
      this.props.getDocumentsWithSearch(null,
        "");
    }
  }

  loadDocumentsByCategory(
    category, link, focus
  ) {
    const {
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      getDocumentsWithSearch,
      getDocumentsWithSearchSimple,
      isDocumentDetails
    } = this.props;
    this.setState({ documentBrowsingCategory: category });
    if (isDocumentDetails) {
      if (!category && category.length === 0) {
        getDocumentsWithSearchSimple(
          link,
          "",
          accountantSelected,
          accountantIdSelected,
          companySelected,
          clientIdSelected,
          false
        );
      } else {
        getDocumentsWithSearchSimple(
          link,
          "",
          accountantSelected,
          accountantIdSelected,
          companySelected,
          clientIdSelected,
          false,
          {
            /* macrocategory: category,*/
            category: category
          }
        );
      }
    } else {
      if (!category && category.length === 0) {
        getDocumentsWithSearch(
          link,
          "",
          false
        );
      } else {
        getDocumentsWithSearch(
          link,
          "",
          false,
          {
            /* macrocategory: category,*/
            category: category
          }
        );
      }
    }

    if (focus) {
      document.getElementById(`${this.props.id}_input`).focus();
    }
  }

  previewDocument(docId) {
    const {
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      loadDocumentDetail,
      loadDocumentPreview
    } = this.props;
    loadDocumentDetail(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      docId
    );
    loadDocumentPreview(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      docId
    );
    this.setState({
      modalZoom: true,
      docId: docId
    });
  }

  addPageModalZoom() {
    const {
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      isLoadingPreview,
      loadDocumentPreview
    } = this.props;
    if (!this.state.docId || isLoadingPreview) {
      return null;
    }
    loadDocumentPreview(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      this.state.docId,
      this.state.modalZoomPage + 1
    );
    this.setState({ modalZoomPage: this.state.modalZoomPage + 1 });
    return undefined;
  }

  addDocument(document) {
    let newdocs = this.state.documents;
    if (!newdocs[document.documentId]) {
      newdocs[document.documentId] = document;
    }
    this.setState({ documents: newdocs });
    if (this.props.addDocument) {
      this.props.addDocument(document, this.props.id);
    }
    this.forceUpdate();
  }

  render() {
    const {
      companySelected,
      clientIdSelected,
      accountantSelected,
      accountantIdSelected,
      fullWidth,
      isLoadingPreview,
      documentPreview,
      placement,
      selected,
      width,
      isDocumentDetails,
      isFoldersEdit,
      user
    } = this.props;
    return (
      <div
        className="documentBrowsingContainer"
        style={{ flex: "1 1 auto", width: fullWidth ? "100%" : "50%", position: "relative" }}
      >
        <>
          <div className="labelDialogContent">
            {isDocumentDetails ? (
              <FormattedMessage id="widgets.documentBrowsing.linkedDocLabel" />
            ) : (
              <>
                <FormattedMessage
                  id={!this.props.inModal ? "widgets.documentBrowsing.label" : "widgets.documentBrowsing.label2"}
                  values={{
                    existing: isFoldersEdit ? (user?.profile?.language === "es-ES" ? "existentes"  : "esistenti") : ""
                  }}
                />
                {isFoldersEdit ? "*" : "" }
              </>
            )}
          </div>
          <div className="inputFascicoliCustom" style={{ width: width }}>
            <Tooltip
              color={"rgb(0, 80, 117)"}
              id={`${this.props.id}_tooltip`}
              visible={this.state.browsingVisible}
              getPopupContainer={trigger => trigger.parentNode}
              trigger={"click"}
              overlayClassName={
                isDocumentDetails
                  ? "DocumentBrowsing-addDocument-tooltip linkedDocTooltip"
                  : "DocumentBrowsing-addDocument-tooltip"
              }
              placement={placement}
              onVisibleChange={visible => {
                if (!visible && !this.state.modalZoom) {
                  this.setState({ browsingVisible: false });
                  if (Object.keys(this.state.documents).length > 0) {
                    document.getElementById(`${this.props.id}_input`).value =
                      "";
                    this.setState({ searchValue: "" });
                    document.getElementById(`${this.props.id}_input`).focus();
                    this.resetDocuments();
                    this.setState({ documentBrowsingPage: 1 });
                  }
                }
              }}
              title={
                <DocumentsCategoryBrowsing
                  currentDocuments={this.state.documents}
                  currentDocumentId={this.props.currentDocumentId}
                  isDocumentDetails={this.props.isDocumentDetails}
                  id={`${this.props.id}_documentBrowsing`}
                  key={`documentBrowsing_${this.state.documents.documentId}`}
                  visible={this.state.browsingVisible}
                  addDocument={this.addDocument.bind(this)}
                  loadDocuments={this.loadDocumentsByCategory.bind(this)}
                  resetDocuments={this.resetDocuments.bind(this)}
                  previewDocument={this.previewDocument.bind(this)}
                  onChangeBrowsingPage={value =>
                    this.setState({ documentBrowsingPage: value })
                  }
                  searchValue={this.state.searchValue}
                  documentBrowsingPage={this.state.documentBrowsingPage}
                  documentBrowsingCategory={this.state.documentBrowsingCategory}
                  selected={selected}
                  onBack={() => {
                    document.getElementById(`${this.props.id}_input`).value =
                      "";
                    this.setState({ searchValue: "" });
                    document.getElementById(`${this.props.id}_input`).focus();
                  }}
                />
              }
            >
              {this.state.modalZoom && (
                <Modal
                  visible={this.state.modalZoom}
                  title={"Anteprima documento"}
                  onClose={e => {
                    this.setState({
                      modalZoom: false,
                      modalZoomImg: "",
                      modalZoomPage: 1
                    });
                    document.getElementsByTagName("body")[0].style.overflow =
                      "auto";
                  }}
                  type="primary"
                  outsideClosable={false}
                >
                  <ModalZoom
                    hideDownload
                    imgSrc={
                      documentPreview && documentPreview.preview
                        ? `data:image/jpeg;base64,${documentPreview.preview}`
                        : null
                    }
                    onClose={() => {
                      this.setState({
                        modalZoom: false,
                        modalZoomImg: "",
                        modalZoomPage: 1
                      });
                    }}
                    openPreviewPage={this.addPageModalZoom.bind(this)}
                    pagesTotal={
                      documentPreview.documents &&
                      documentPreview.documents[this.state.docId]
                        ? documentPreview.documents[this.state.docId]
                          .numberOfPages
                        : 1
                    }
                    isLoading={isLoadingPreview}
                    waitForLoading={true}
                    transparentBackground={true}
                  />
                </Modal>
              )}
              <DebounceInput
                id={`${this.props.id}_input`}
                maxLength={30}
                allowClear={false}
                autoComplete={"off"}
                onChange={value => {
                  this.props.clearDocumentsWithSearch();
                  this.setState({ searchValue: value });
                  if (
                    this.state.documentBrowsingPage === 2 &&
                    value.length < 3 &&
                    !this.props.documentsWithSearch
                      .isGettingDocumentsWithSearch &&
                    this.state.documentBrowsingCategory === ""
                  ) {
                    this.setState({ documentBrowsingPage: 1 });
                    isDocumentDetails
                      ? this.props.getDocumentsWithSearchSimple(
                        null,
                        "",
                        this.props.accountantSelected,
                        accountantIdSelected,
                        this.props.companySelected,
                        this.props.clientIdSelected
                      )
                      : this.props.getDocumentsWithSearch(null,
                        "");
                  } else if (
                    this.state.documentBrowsingPage === 2 &&
                    value.length < 3 &&
                    !this.props.documentsWithSearch.isGettingDocumentsWithSearch
                  ) {
                    isDocumentDetails
                      ? this.props.getDocumentsWithSearchSimple(
                        null,
                        "",
                        accountantSelected,
                        accountantIdSelected,
                        companySelected,
                        clientIdSelected,
                        false,
                        this.state.documentBrowsingCategory !== ""
                          ? { category: this.state.documentBrowsingCategory }
                          : {}
                      )
                      : this.props.getDocumentsWithSearch(
                        null,
                        "",
                        false,
                        this.state.documentBrowsingCategory !== ""
                          ? { category: this.state.documentBrowsingCategory }
                          : {}
                      );
                  } else if (
                    this.state.documentBrowsingPage === 2 &&
                    value.length > 2 &&
                    !this.props.documentsWithSearch.isGettingDocumentsWithSearch
                  ) {
                    isDocumentDetails
                      ? this.props.getDocumentsWithSearchSimple(
                        null,
                        value,
                        accountantSelected,
                        accountantIdSelected,
                        companySelected,
                        clientIdSelected,
                        false,
                        this.state.documentBrowsingCategory !== ""
                          ? { category: this.state.documentBrowsingCategory }
                          : {}
                      )
                      : this.props.getDocumentsWithSearch(
                        null,
                        value,
                        false,
                        this.state.documentBrowsingCategory !== ""
                          ? { category: this.state.documentBrowsingCategory }
                          : {}
                      );
                  } else if (
                    (this.state.documentBrowsingPage === 1 ||
                      this.state.documentBrowsingCategory === "") &&
                    value.length > 2 &&
                    !this.props.documentsWithSearch.isGettingDocumentsWithSearch
                  ) {
                    this.setState({
                      documentBrowsingPage: 2,
                      documentBrowsingCategory: ""
                    });
                    isDocumentDetails
                      ? this.props.getDocumentsWithSearchSimple(
                        null,
                        value,
                        accountantSelected,
                        accountantIdSelected,
                        companySelected,
                        clientIdSelected,
                        false
                      )
                      : this.props.getDocumentsWithSearch(
                        null,
                        value,
                        false
                      );
                  }
                }}
                placeholder={this.props.intl.formatMessage({
                  id: "widgets.documentBrowsing.placeholder"
                })}
                onClick={() => {
                  this.setState({ browsingVisible: true });
                }}
                suffix={<FontAwesomeIcon icon={["far", "search"]} />}
                value={this.state.searchValue}
              />
            </Tooltip>
          </div>
        </>
      </div>
    );
  }
}

DocumentBrowsing.propTypes = {
  id: PropTypes.string.isRequired,
  addDocument: PropTypes.func,
  fullWidth: PropTypes.bool,
  placement: PropTypes.oneOf(["bottom", "top"]),
  width: PropTypes.string,
  selected: PropTypes.array,
  isDocumentDetails: PropTypes.bool
};

DocumentBrowsing.defaultProps = {
  placement: "bottom",
  width: "100%",
  fullWidth: false,
  selected: {},
  isDocumentDetails: false
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    company: state.company,
    documentsWithSearch: state.documentsWithSearch,
    documentPreview: state.documentPreview,
    isLoadingPreview: state.documentPreview.isLoadingPreview,
    getDocumentsSimple: state.documentsWithSearch.getDocumentsSimple,
    user: state.user
  };
}

const mapDispatchToProps = dispatch => ({
  clearDocumentsWithSearch: () => dispatch(clearDocumentsWithSearch()),
  getDocumentsWithSearch: (
    link,
    txtSearch,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    isAppend,
    additionalParams
  ) =>
    dispatch(getDocumentsWithSearch(
      link,
      txtSearch,
      isAppend,
      additionalParams
    )),
  getDocumentsWithSearchSimple: (
    link,
    txtSearch,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    isAppend,
    additionalParams
  ) =>
    dispatch(getDocumentsWithSearchSimple(
      link,
      txtSearch,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      isAppend,
      additionalParams
    )),
  loadDocumentPreview: (
    auth,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    idAttachment,
    page
  ) =>
    dispatch(loadDocumentPreview(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      idAttachment,
      page
    )),
  loadDocumentDetail: (
    auth,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    idAttachment
  ) =>
    dispatch(loadDocumentDetail(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      idAttachment
    ))
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DocumentBrowsing));
